import { render, staticRenderFns } from "./WalmartReports.vue?vue&type=template&id=52a5cd3e&scoped=true"
import script from "./WalmartReports.vue?vue&type=script&lang=js"
export * from "./WalmartReports.vue?vue&type=script&lang=js"
import style0 from "./WalmartReports.vue?vue&type=style&index=0&id=52a5cd3e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52a5cd3e",
  null
  
)

export default component.exports